// extracted by mini-css-extract-plugin
export var alertIcon = "_ss-0";